import classNames from 'classnames';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../videosAssignmentState/videosAssignmentContext';
import React, { useContext, useEffect } from 'react';
import CustomerCrumb from './components/CustomerCrumb';
import RestaurantCrumb from './components/RestaurantCrumb';
import VideosCrumb from './components/VideosCrumb';
import style from './Breadcrumbs.module.scss';

const Breadcrumbs: React.FC = () => {
	const { setShowBreadcrumbs, isShowBreadcrumbs, IDsSelectedCustomers } =
		useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	const containerClasses = classNames(style.container, { [style.hidden]: !isShowBreadcrumbs });

	const emptyCustomers = !Object.keys(IDsSelectedCustomers).length;

	useEffect(() => {
		emptyCustomers && setShowBreadcrumbs(false);
	}, [emptyCustomers]);

	return (
		<div className={containerClasses} data-test="Breadcrumbs">
			<CustomerCrumb />
			<RestaurantCrumb />
			<VideosCrumb />
		</div>
	);
};

export default Breadcrumbs;
